import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import ReactPlayer from "react-player";
import { RiCloseCircleFill } from "react-icons/ri";
// import { useVideoAnalytics } from "../../analytics/hooks/useVideoAnalytics";
import "./SimplePlayer.css";

const SimplePlayer = ({
  openModal,
  closeModal,
  videoUrl,
  thumbnail,
  title,
  videoId,
  shouldTrack = false,
}) => {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null);

  // const analytics = useVideoAnalytics({
  //   videoId,
  //   shouldTrack,
  // });

  if (!openModal || !videoUrl) return null;

  const handleClose = () => {
    setPlaying(false);
    // analytics.terminateSession();
    closeModal(false);
  };

  return createPortal(
    <div className="simple-player-modal">
      <button onClick={handleClose} className="simple-player-close">
        <RiCloseCircleFill color="white" size={36} />
      </button>

      <div className="simple-player-wrapper">
        <div className="single-player-container">
          <ReactPlayer
            key={videoUrl}
            ref={playerRef}
            url={videoUrl}
            playing={playing}
            controls={true}
            width="100%"
            height="100%"
            progressInterval={1000}
            // onDuration={analytics.updateDuration}
            // onProgress={analytics.updateProgress}
            config={{
              file: {
                attributes: {
                  preload: "metadata",
                  playsInline: true,
                  poster: thumbnail,
                  style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  },
                  onContextMenu: (e) => e.preventDefault(),
                  disablePictureInPicture: true,
                  controlsList: "nodownload noplaybackrate",
                },
              },
            }}
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SimplePlayer;
